import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import './LiksPageHeading.css';

export type LiksPageHeadingItem = {
  label: React.ReactNode;
  to?: string;
  icon?: React.ReactNode;
};

export type LiksPageHeadingProps = {
  items: LiksPageHeadingItem[];
  'aria-label': string;
  className?: string;
};

export function LiksPageHeading({
  items,
  'aria-label': ariaLabel,
  className,
}: LiksPageHeadingProps) {
  const classNames = ['liks-page-heading', className].filter(Boolean);

  return (
    <header className={classNames.join(' ')}>
      <nav className="liks-page-heading__nav" aria-label={ariaLabel}>
        <h1>
          {items.map((item, index) => {
            const key = `${index}:${typeof item.label === 'string' ? item.label : (item.to ?? 'current')}`;

            return (
              <Fragment key={key}>
                {index > 0 ? (
                  <span
                    className="liks-page-heading__separator"
                    aria-hidden="true"
                  >
                    ›
                  </span>
                ) : null}
                {item.to != null ? (
                  <Link className="liks-page-heading__link" to={item.to}>
                    {item.label}
                  </Link>
                ) : (
                  <span className="liks-page-heading__current">
                    {item.icon != null ? (
                      <span className="liks-page-heading__icon" aria-hidden>
                        {item.icon}
                      </span>
                    ) : null}
                    <span className="liks-page-heading__name">
                      {item.label}
                    </span>
                  </span>
                )}
              </Fragment>
            );
          })}
        </h1>
      </nav>
    </header>
  );
}
